import React, { useState } from 'react';
import { motion } from "framer-motion";
import "../css/turnoNuevo.css";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Button } from '@mui/material';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import QrCodeIcon from '@mui/icons-material/QrCode';
import TurnoPDF from './TurnoPDF';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Cuerre from './Cuerre';

function NuevoTurno(props) {

  const [datosTurno, setDatosTurno] = useState({dni: 0, email: ""});
  const [pidioPDF, setPidioPDF] = useState(false);
  const depTurno = props.idDependencia;
  const idDepCulMunro = props.idCulMunro;
  const listaQrs = props.qr;

  console.log(listaQrs);

  
  
  return (
    <motion.div 
      className='gestor-turno'
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.8 }} >

        <div className='container-turno'>
            <div className='turno-titulo'>
                <Button color='success' style={{"pointer-events": "none"}}><CheckCircleOutlineIcon style={{"minWidth": "50", "width": "70", "height": "70"}} /></Button>
                <p> {depTurno==idDepCulMunro? "La reserva fue realizada" : "El turno fue guardado"}  exitosamente </p>
            </div>

            <div style={{"display": "flex", "flexDirection":"column"}}>
                <div className='turno-campo'>
                    <p className='label-turno'> Nombre:</p>
                    <p className='contenido-turno'>{props.nombre}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> DNI:</p>
                    <p className='contenido-turno'>{props.dni}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> N° de {props.idDependencia==idDepCulMunro? "reserva" : "turno"}:</p>
                    <p className='contenido-turno'>{props.codigo}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> {props.idDependencia==idDepCulMunro? "Fecha de función" : "Fecha"}:</p>
                    <p className='contenido-turno'>{props.fecha}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> Hora:</p>
                    <p className='contenido-turno'>{props.hora}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> Lugar:</p>
                    <p className='contenido-turno'>{props.lugar}</p>
                </div>
                <hr/>
                {props.idDependencia!=idDepCulMunro && <div className='turno-campo'>
                    <p className='label-turno'> Módulo:</p>
                    <p className='contenido-turno'>{props.modulo}</p>
                </div>}
                {props.idDependencia!=idDepCulMunro && <hr/>}
                <div className='turno-campo'>
                    <p className='label-turno'> {props.idDependencia==idDepCulMunro? "Sede" : "Dependencia"}:</p>
                    <p className='contenido-turno'>{props.dependencia}</p>
                </div>
                <hr/>
                <div className='turno-campo'>
                    <p className='label-turno'> {props.idDependencia==idDepCulMunro? "Función" : "Servicio"}:</p>
                    <p className='contenido-turno'>{props.servicio}</p>
                </div>
                <hr/>
                {props.mostrarInteresado && 
                  <>
                  <div className='turno-campo'>
                    <p className='label-turno'> DNI del interesado:</p>
                    <p className='contenido-turno'>{props.dniInteresado}</p>
                  </div>
                  <hr/>
                  <div className='turno-campo'>
                      <p className='label-turno'> Nombre del interesado:</p>
                      <p className='contenido-turno'>{props.nombreInteresado}</p>
                  </div>
                  <hr/>
                  <div className='turno-campo'>
                      <p className='label-turno'> Apellido del interesado:</p>
                      <p className='contenido-turno'>{props.apellidoInteresado}</p>
                  </div>
                <hr/>
                </>
                }
                
              {/* <div style={{"display":"flex", "justifyContent":"center"}}>
                <img src={`data:image/png;base64,${listaQrs[0].image}`} style={{"width":"250px"}} />
              </div>
              {listaQrs.length > 1 && <div style={{"display":"flex", "justifyContent":"center"}}>
                <img src={`data:image/png;base64,${listaQrs[1].image}`} style={{"width":"250px"}} />
              </div>} */}
              <div style={{"display":"flex", "justifyContent":"center", "flexDirection": "column", "alignItems": "center"}}>
                {listaQrs.map((qr, index) => (
                  <div key={index} style={{"display":"flex", "justifyContent":"center", "marginBottom": "10px"}}>
                    <img src={`data:image/png;base64,${qr.image}`} style={{"width":"250px"}} />
                  </div>
                ))}
              </div>
            </div>
            {/* <div className='cont-boton'>
            <Button 
                    sx={{height: 60}}
                    variant='contained' 
                    type='button' 
                    color='secondary'
                    className='boton-gestion-turno'
                    endIcon={<ArrowCircleDownIcon/>}
                    onClick={() => {
                      if(pidioPDF){
                        setPidioPDF(false);
                      }
                      else setPidioPDF(true);

                    }}>DESCARGAR PDF</Button>
          </div> */}
            <PDFDownloadLink
              className='cont-boton'
              style={{"textDecoration": "none"}}
              document={<Cuerre datos={props} dependencia={props.idDependencia}/>}
              fileName='Turno_Qr'
            >
              <Button 
                      sx={{height: 60}}
                      variant='contained' 
                      type='button' 
                      color='secondary'
                      className='boton-gestion-turno2'
                      endIcon={<QrCodeIcon/>}
              >DESCARGAR RESERVA</Button>
            </PDFDownloadLink>
          <div className='cont-boton'>
            <Button 
                    variant='contained' 
                    type='button' 
                    color='secondary'
                    className='boton-gestion-turno2'
                    // href='/'
                    onClick={() => {
                      window.location.reload();
                    }}>{props.idDependencia==idDepCulMunro? "NUEVA RESERVA" : "NUEVO TURNO"}</Button>
          </div>

          <p className='letra-chica'>
            No es necesario imprimir {props.idDependencia==idDepCulMunro? "la reserva generada" : "el turno generado"}. <br/>
            Hemos enviado un email a tu casilla de correo electrónico con los datos {props.idDependencia==idDepCulMunro? "de la función" : "del turno"}.
          </p>
        </div>
    
        {pidioPDF && <TurnoPDF codigo={props.codigo} fecha={props.fecha} hora={props.hora} lugar={props.lugar} servicio={props.servicio}/>}
      
    </motion.div>
  );
}

export default NuevoTurno;
